const l = "6.13.2";
function E(r, e, t) {
  const n = e.split("|").map((i) => i.trim());
  for (let i = 0; i < n.length; i++)
    switch (e) {
      case "any":
        return;
      case "bigint":
      case "boolean":
      case "number":
      case "string":
        if (typeof r === e)
          return;
    }
  const o = new Error(`invalid value for type ${e}`);
  throw o.code = "INVALID_ARGUMENT", o.argument = `value.${t}`, o.value = r, o;
}
async function y(r) {
  const e = Object.keys(r);
  return (await Promise.all(e.map((n) => Promise.resolve(r[n])))).reduce((n, o, i) => (n[e[i]] = o, n), {});
}
function f(r, e, t) {
  for (let n in e) {
    let o = e[n];
    const i = t ? t[n] : null;
    i && E(o, i, n), Object.defineProperty(r, n, { enumerable: !0, value: o, writable: !1 });
  }
}
function s(r) {
  if (r == null)
    return "null";
  if (Array.isArray(r))
    return "[ " + r.map(s).join(", ") + " ]";
  if (r instanceof Uint8Array) {
    const e = "0123456789abcdef";
    let t = "0x";
    for (let n = 0; n < r.length; n++)
      t += e[r[n] >> 4], t += e[r[n] & 15];
    return t;
  }
  if (typeof r == "object" && typeof r.toJSON == "function")
    return s(r.toJSON());
  switch (typeof r) {
    case "boolean":
    case "symbol":
      return r.toString();
    case "bigint":
      return BigInt(r).toString();
    case "number":
      return r.toString();
    case "string":
      return JSON.stringify(r);
    case "object": {
      const e = Object.keys(r);
      return e.sort(), "{ " + e.map((t) => `${s(t)}: ${s(r[t])}`).join(", ") + " }";
    }
  }
  return "[ COULD NOT SERIALIZE ]";
}
function h(r, e) {
  return r && r.code === e;
}
function b(r) {
  return h(r, "CALL_EXCEPTION");
}
function p(r, e, t) {
  let n = r;
  {
    const i = [];
    if (t) {
      if ("message" in t || "code" in t || "name" in t)
        throw new Error(`value will overwrite populated values: ${s(t)}`);
      for (const a in t) {
        if (a === "shortMessage")
          continue;
        const u = t[a];
        i.push(a + "=" + s(u));
      }
    }
    i.push(`code=${e}`), i.push(`version=${l}`), i.length && (r += " (" + i.join(", ") + ")");
  }
  let o;
  switch (e) {
    case "INVALID_ARGUMENT":
      o = new TypeError(r);
      break;
    case "NUMERIC_FAULT":
    case "BUFFER_OVERRUN":
      o = new RangeError(r);
      break;
    default:
      o = new Error(r);
  }
  return f(o, { code: e }), t && Object.assign(o, t), o.shortMessage == null && f(o, { shortMessage: n }), o;
}
function c(r, e, t, n) {
  if (!r)
    throw p(e, t, n);
}
function N(r, e, t, n) {
  c(r, e, "INVALID_ARGUMENT", { argument: t, value: n });
}
function w(r, e, t) {
  t == null && (t = ""), t && (t = ": " + t), c(r >= e, "missing arguemnt" + t, "MISSING_ARGUMENT", {
    count: r,
    expectedCount: e
  }), c(r <= e, "too many arguments" + t, "UNEXPECTED_ARGUMENT", {
    count: r,
    expectedCount: e
  });
}
["NFD", "NFC", "NFKD", "NFKC"].reduce((r, e) => {
  try {
    if ("test".normalize(e) !== "test")
      throw new Error("bad");
    if (e === "NFD" && "é".normalize("NFD") !== "é")
      throw new Error("broken");
    r.push(e);
  } catch {
  }
  return r;
}, []);
function d(r, e, t) {
  if (t == null && (t = ""), r !== e) {
    let n = t, o = "new";
    t && (n += ".", o += " " + t), c(!1, `private constructor; use ${n}from* methods`, "UNSUPPORTED_OPERATION", {
      operation: o
    });
  }
}
export {
  N as a,
  c as b,
  d as c,
  f as d,
  w as e,
  b as f,
  h as i,
  p as m,
  y as r
};
